module.exports = __webpack_public_path__ + "img/aero-logo.981dd5cb.png";